/**
 * project navigation
 * @param { string } to - link path
 * @param { string } title - link title
 * ---
 * @param to must be on of the tow cases
 * 1- for internal categories: is must be the category id
 * 2- for external links: 'folder' name which will be included '/public/{project_id}/folder'
 * ---
 * in error case in @param to (when no actual associated category found)
 * the link will be rendered as external link
 *
 */

export default [
  { to: 'lakemedel', title: 'Intro' },
  { to: 'showroom', title: 'Administratör A' },
  { to: 'ambulans', title: 'Administratör B' },
  { to: 'strama', title: 'EKG' },
  { to: 'external_content_demo', title: 'Interaktivt flöde' },
  { to: 'test_html', title: 'Kalkylator Demo' },
  { to: 'customer_demo', title: 'Kund Demo' },
  { to: 'changelog', title: 'Ändringslogg' },
];
